<template>
  <div class="lotus_content">
    <section class="box_page_content_2">
      <h3>{{ $t("address.title") }}</h3>
      <div class="_cap">{{ $t("address.cap") }}</div>
      <div class="box3 form_style1">
        <div class="_inbox">
          <div class="_inbox1">
            <validation-observer ref="insert_address" tag="div" class="form">
              <validation-provider
                v-bind:name="$t('address.full_name')"
                tag="div"
                class="mb_3"
                v-slot="{ errors }"
                :rules="
                  currentLocale === 'en' ? 'required-en|name' : 'required|name'
                "
              >
                <div
                  class="_fff"
                  :class="
                    errors && typeof errors[0] !== 'undefined' ? '_error' : ''
                  "
                >
                  <label for="fullname" class="form-label">{{
                    $t("address.full_name")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="fullname"
                    aria-describedby="fullnameError"
                    autocomplete="nope"
                    v-model="name"
                  />
                  <div id="fullnameError" class="form-text">
                    {{ errors[0] }}
                  </div>
                </div>
              </validation-provider>
              <div class="mb_3">
                <div class="row">
                  <validation-provider
                    v-bind:name="$t('address.phone')"
                    v-slot="{ errors }"
                    tag="div"
                    class="col-md-12"
                    :rules="
                      currentLocale === 'en'
                        ? 'required-en|phone_mask_en'
                        : 'required|phone_mask'
                    "
                  >
                    <div
                      class="_fff"
                      :class="
                        errors && typeof errors[0] !== 'undefined'
                          ? '_error'
                          : ''
                      "
                    >
                      <label for="phone" class="form-label">{{
                        $t("address.phone")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        aria-describedby="phoneError"
                        autocomplete="nope"
                        v-model="phone"
                        v-mask="'#### ### ###'"
                      />
                      <div id="phoneError" class="form-text">
                        {{ errors[0] }}
                      </div>
                    </div>
                  </validation-provider>
                  <validation-provider
                    v-bind:name="$t('address.address')"
                    v-slot="{ errors }"
                    tag="div"
                    class="col-md-12"
                    :rules="currentLocale === 'en' ? 'required-en' : 'required'"
                  >
                    <div
                      class="_fff"
                      :class="
                        errors && typeof errors[0] !== 'undefined'
                          ? '_error'
                          : ''
                      "
                    >
                      <label for="address" class="form-label">{{
                        $t("address.address")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        v-model="address"
                        aria-describedby="addressError"
                        autocomplete="nope"
                      />
                      <div id="addressError" class="form-text">
                        {{ errors[0] }}
                      </div>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="mb_3">
                <div class="row">
                  <validation-provider
                    v-bind:name="$t('address.city')"
                    v-slot="{ errors }"
                    tag="div"
                    class="col-md-12"
                    :rules="
                      currentLocale === 'en'
                        ? 'required-select-en'
                        : 'required-select'
                    "
                  >
                    <div
                      class="_fff"
                      :class="
                        errors && typeof errors[0] !== 'undefined'
                          ? '_error'
                          : ''
                      "
                    >
                      <label for="city" class="form-label">{{
                        $t("address.city")
                      }}</label>
                      <select
                        class="form-select"
                        aria-describedby="cityError"
                        v-model="city_id"
                        id="city"
                        required
                      >
                        <option value="0" disabled selected>
                          {{ $t("address.placeholder_city") }}
                        </option>
                        <option
                          v-for="city in cities"
                          :key="city.id"
                          :value="city.id"
                        >
                          {{ city.title }}
                        </option>
                      </select>
                      <div id="cityError" class="form-text">
                        {{ errors[0] }}
                      </div>
                    </div>
                  </validation-provider>
                  <validation-provider
                    v-bind:name="$t('address.district')"
                    v-slot="{ errors }"
                    tag="div"
                    class="col-md-12"
                    :rules="
                      currentLocale === 'en'
                        ? 'required-select-en'
                        : 'required-select'
                    "
                  >
                    <div
                      class="_fff"
                      :class="
                        errors && typeof errors[0] !== 'undefined'
                          ? '_error'
                          : ''
                      "
                    >
                      <label for="town" class="form-label">{{
                        $t("address.district")
                      }}</label>
                      <select
                        class="form-select"
                        aria-describedby="townError"
                        id="town"
                        required
                        v-model="district_id"
                      >
                        <option value="0" disabled selected>
                          {{ $t("address.placeholder_district") }}
                        </option>
                        <template v-if="districts && districts.length > 0">
                          <option
                            v-for="district in districts"
                            :key="district.id"
                            :value="district.id"
                          >
                            {{ district.prefix + " " + district.title }}
                          </option>
                        </template>
                      </select>
                      <div id="townError" class="form-text">
                        {{ errors[0] }}
                      </div>
                    </div>
                  </validation-provider>
                  <validation-provider
                    v-bind:name="$t('address.ward')"
                    v-slot="{ errors }"
                    tag="div"
                    class="col-md-12"
                    :rules="
                      currentLocale === 'en'
                        ? 'required-select-en'
                        : 'required-select'
                    "
                  >
                    <div
                      class="_fff"
                      :class="
                        errors && typeof errors[0] !== 'undefined'
                          ? '_error'
                          : ''
                      "
                    >
                      <label for="district" class="form-label">{{
                        $t("address.ward")
                      }}</label>
                      <select
                        class="form-select"
                        aria-describedby="districtError"
                        id="district"
                        required
                        v-model="ward_id"
                      >
                        <option value="0" disabled selected>
                          {{ $t("address.placeholder_ward") }}
                        </option>
                        <template v-if="wards && wards.length > 0">
                          <option
                            v-for="ward in wards"
                            :key="ward.id"
                            :value="ward.id"
                          >
                            {{ ward.prefix + " " + ward.title }}
                          </option>
                        </template>
                      </select>
                      <div id="districtError" class="form-text">
                        {{ errors[0] }}
                      </div>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="mb_3 _fff">
                <label for="note" class="form-label">{{
                  $t("address.note")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="note"
                  aria-describedby="noteError"
                  v-bind:placeholder="$t('address.placeholder_note')"
                  autocomplete="nope"
                  v-model="note"
                />
                <div id="noteError" class="form-text"></div>
              </div>
              <div class="mb_3 form-check _fff">
                <div>
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="okie_check"
                    autocomplete="nope"
                    v-model="isAllow"
                  />
                  <label class="form-check-label" for="okie_check">
                    {{ $t("address.accept") }}
                  </label>
                  <div id="okie_checkError" class="form-text"></div>
                </div>
              </div>
              <div class="_foot text-center">
                <a
                  href="javascript:;"
                  v-on:click="insertAddress()"
                  class="btn btn-x2"
                >
                  <span>{{ $t("address.confirm") }}</span>
                </a>
              </div>
            </validation-observer>
          </div>
        </div>
      </div>
      <!--      <div class="__x2">-->
      <!--        <router-link :to="{name: 'luckyDraw'}" tag="a">-->
      <!--          <img src="@/assets/images/close.png"/>-->
      <!--        </router-link>-->
      <!--      </div>-->
    </section>
    <!--FOOTER-->
    <footer class="d-flex flex-wrap px-content-1">
      <p class="flex-grow-1">
        Hotline: <a href="tel:1900299232">1900 299 232</a>
      </p>
      <p>
        <a href="#" class="d-flex align-items-center">
          <img src="@/assets/images/ub_logo.svg" />
          <span>Powered by UrBox</span>
        </a>
      </p>
    </footer>
    <div class="modals">
      <div
        class="modal fade"
        id="modal-physical-otp"
        tabindex="-1"
        aria-labelledby="modal_OtpLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal_otp">
          <div class="modal-content">
            <div class="modal-header">
              <a href="javascript:;">
                <img src="@/assets/images/banner_welcome.png" />
              </a>
            </div>
            <div class="modal-body bcontent_1">
              <h4>{{ $t("modal.otp_input.title") }}</h4>
              <div class="_des">
                {{
                  $t("modal.otp_input.message", {
                    phone: "******" + phone.slice(6),
                  })
                }}
                <div class="d-flex justify-content-center w-100 mt-2">
                  <otp-input
                    mode="group"
                    :isValid="isOtpValid"
                    :digits="digits"
                    @on-complete="onCompleteHandler"
                    @on-changed="onChangedHandler"
                    @on-paste="onPasteHandler"
                  />
                </div>
                <!-- COUNTING DOWN - NO ERROR -->
                <div
                  v-if="
                    otpTimeRemaing > 0 &&
                    isOtpValid &&
                    !isOtpRespondLimitExceeded
                  "
                  class="otp_expired mt-2"
                >
                  {{
                    $t("modal.otp_input.expire", {
                      time_left: formatTime(otpTimeRemaing),
                    })
                  }}
                </div>
                <!-- OPT INVALID OR EXPIRED -->
                <div
                  v-if="otpTimeRemaing <= 0 || !isOtpValid"
                  class="d-flex justify-content-between mt-2"
                >
                  <div class="d-flex align-items-center">
                    <img src="@/assets/images/alert.png" class="error_icon" />
                    <span class="error_message">{{
                      $t("modal.otp_input.error")
                    }}</span>
                  </div>
                  <span
                    v-if="otpTimeRemaing <= 0"
                    v-on:click="handleResendOtp"
                    class="send_otp_btn"
                    >{{ $t("modal.otp_input.resend_otp") }}</span
                  >
                  <span v-if="otpTimeRemaing > 0" class="send_otp_btn">{{
                    $t("modal.otp_input.resend_otp_remaining_time", {
                      time_left: formatTime(otpTimeRemaing),
                    })
                  }}</span>
                </div>
                <!-- EXCEEDED NUMBER OF OTP ATTEMPTS -->
                <div
                  v-if="isOtpRespondLimitExceeded"
                  class="d-flex justify-content-between mt-2"
                >
                  <div class="d-flex align-items-center">
                    <img src="@/assets/images/alert.png" class="error_icon" />
                    <span class="error_message">{{
                      $t("modal.otp_input.error_attempt_limit_exceeded")
                    }}</span>
                  </div>
                  <span
                    v-if="otpTimeRemaing <= 0"
                    v-on:click="handleResendOtp"
                    class="send_otp_btn"
                    >{{ $t("modal.otp_input.resend_otp") }}</span
                  >
                </div>
              </div>
              <div class="_act">
                <a
                  href="javascript:;"
                  class="btn btn-x2"
                  v-on:click="onSubmitCartOtp"
                  ><span>{{ $t("modal.address.confirm") }}</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  INSERT_ADDRESS,
  LIST_CITY,
  LIST_DISTRICT,
  LIST_WARD,
  VALID_OTP,
} from "@/stores/actions";
import { mapGetters } from "vuex";
import { GAME_APP } from "@/enums";
import JwtService from "@/jwt-service";
import OtpInput from "otp-input-vue2";

const OTP_EXPIRED_TIME = 300;
let allIntervals = [];
const clearAllIntervals = () => {
  for (let i = 0; i < allIntervals.length; ++i) {
    clearInterval(allIntervals[i]);
  }
  allIntervals = [];
};

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Address",
  created() {
    let vm = this;
    vm.getCities();
  },
  components: { OtpInput },
  data() {
    return {
      name: "",
      phone: "",
      address: "",
      city_id: 0,
      district_id: 0,
      ward_id: 0,
      note: "",
      isAllow: false,
      isSubmit: false,
      cacheCity: 0,
      cacheDistrict: 0,
      currentOtp: "",
      isPhoneInvalid: false,
      sendOtpFail: false,
      isOtpRequestLimitExceeded: false,
      isOtpValid: true,
      isOtpRespondLimitExceeded: false,
      digits: 6,
      otpTimeRemaing: OTP_EXPIRED_TIME,
    };
  },
  computed: {
    ...mapGetters(["cities", "districts", "wards", "winGift", "currentUser"]),
    currentLocale() {
      let vm = this;
      return vm.$route.params.locale;
    },
  },
  watch: {
    city_id: {
      handler(after) {
        let vm = this;
        if (after !== vm.cacheCity) {
          vm.district_id = 0;
          vm.ward_id = 0;
          vm.getDistrictByCity();
        }
      },
      deep: true,
    },
    district_id: {
      handler(after) {
        let vm = this;
        if (after !== vm.cacheDistrict && after !== 0) {
          vm.ward_id = 0;
          vm.getWardByDistrict();
        }
      },
      deep: true,
    },
  },
  methods: {
    onCompleteHandler(code) {
      this.currentOtp = code;
      this.isOtpValid = true;
    },

    onChangedHandler(lastEnteredCode) {
      console.log("code changed", lastEnteredCode);
    },

    onPasteHandler(code) {
      console.log("code pasted", code);
    },
    insertAddress() {
      let vm = this;
      vm.isValidated("insert_address").then((response) => {
        if (response) {
          if (vm.isAllow && !vm.isSubmit) {
            vm.isSubmit = true;
            vm.$store
              .dispatch(INSERT_ADDRESS, {
                app_id: GAME_APP.APP_ID,
                cart_id: vm.winGift.cart_id || 0,
                receiver_name: vm.name,
                receiver_phone: vm.replaceSpace(vm.phone),
                receiver_city_id: vm.city_id,
                receiver_district_id: vm.district_id,
                receiver_ward_id: vm.ward_id,
                receiver_address: vm.address,
                receiver_note: vm.note,
              })
              .then((response) => {
                // eslint-disable-next-line no-undef
                let modalError = $("#modal-error");
                if (response && response.data) {
                  $("#modal-address-success").modal("show");
                } else {
                  modalError.modal("show");
                }
                vm.isSubmit = false;
              });
          }
        }
      });
    },

    getShipAddress() {
      let vm = this;
      return (
        vm.address +
        " - " +
        vm.getWardName() +
        " - " +
        vm.getDistrictName() +
        " - " +
        vm.getCityName()
      );
    },

    getCityName() {
      let vm = this;
      let city = vm.cities.find(function (item) {
        return item.id === vm.city_id;
      });
      return city ? city.title : "";
    },

    getDistrictName() {
      let vm = this;
      let district = vm.districts.find(function (item) {
        return item.id === vm.district_id;
      });
      return district ? district.prefix + " " + district.title : "";
    },

    getWardName() {
      let vm = this;
      let ward = vm.wards.find(function (item) {
        return item.id === vm.ward_id;
      });
      return ward ? ward.prefix + " " + ward.title : "";
    },

    getCities() {
      let vm = this;
      vm.$store.dispatch(LIST_CITY).then(() => {});
    },
    getDistrictByCity() {
      let vm = this;
      vm.$store.dispatch(LIST_DISTRICT, { city_id: vm.city_id }).then(() => {});
    },
    getWardByDistrict() {
      let vm = this;
      vm.$store
        .dispatch(LIST_WARD, { district_id: vm.district_id })
        .then(() => {});
    },

    onSubmitCartOtp() {
      let vm = this;
      if (vm.isOtpValid && vm.currentOtp.length === 6) {
        vm.$store
          .dispatch(VALID_OTP, {
            phone_number: JwtService.getCustomerPhone(),
            otp: vm.currentOtp,
            game_id: GAME_APP.ID,
            app_id: GAME_APP.APP_ID,
            action: "cart_address",
          })
          .then((res) => {
            if (res && res.status === 200) {
              const { data } = res;
              if (data.code === 1) {
                $("#modal-physical-otp").modal("hide");
                $("#modal-address-success").modal("show");
              } else if (data.code === 3) {
                vm.isOtpRespondLimitExceeded = true; //5 wrong try
                clearAllIntervals();
              } else {
                vm.isOtpValid = false;
              }
            }
          });
      }
    },
  },
};
</script>

<style scoped></style>
